import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { RefreshHomeService } from 'src/app/services/refresh-home.service';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);
  private readonly refreshHomeService = inject(RefreshHomeService);

  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.checkAdjustedData();

    this.refreshHomeService.refreshHome$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.checkAdjustedData();
      });
  }

  private checkAdjustedData(): void {
    const adjustedData = sessionStorage.getItem('adjustedData');

    if (adjustedData === 'false') {
      this.dialog
        .open(ModalComponent, {
          data: {
            type: 'my-data-modal',
          },
        })
        .afterClosed()
        .subscribe(() => {
          this.router.navigate(['/panel/my-data']);
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
